<<template>
  <div id="ui-slider" :style="{ backgroundImage: linearGradient }">
      <div :style="{ backgroundColor: color }" class="color-picker__handle ui-slider-handle"></div>
  </div>
</template>

<<script>
export default {
  name: "color-picker",
  props: {
  defaultValue: {
      type: Number,
      default: 136,
      required: true,
      validator: value => {
        return value >= 0 && value <= 360;
      }
    },
    saturation: {
      type: Number,
      default: 50,
      required: true,
      validator: value => {
        return value >= 0 && value <= 100;
      }
    },
    lightness: {
      type: Number,
      default: 50,
      required: true,
      validator: value => {
        return value >= 0 && value <= 100;
      }
    }
  },
  data() {
      return {
          value: this.defaultValue,
          // saturation: 61,
          // lightness: 49
      }
  },
  computed: {
      color: function() {
      return tinycolor(`hsl(${this.value}, ${this.saturation}%, ${this.lightness}%)`).toHexString();
    },
    linearGradient: function() {
      let gradient = "linear-gradient(to right, ";
      let iterations = 6;
      for (let i = 0; i <= 6; i++) {
        let string =
          tinycolor(
            `hsl(${360 / iterations * i}, ${this.saturation}%, ${this.lightness}%)`
          ).toHexString() + " " + 100 / iterations * i + "%";

        if (i !== iterations) string += ", ";
        gradient += string;
      }
      gradient += ")";
      // console.log(gradient);
      return gradient;
    }
  },
  watch: {
    color: function() {
      this.$emit("change-color", this.color);
    }
  },
  mounted: function() {
    let vm = this;
    $(this.$el).slider({
    max: 360,
    value: vm.value,
    slide: function(e, ui) {
      vm.value = ui.value;
    }
  });
  }
}
</script>



// WEBPACK FOOTER //
// color-picker.vue?41ec14bc